// remember to update confluence page after modifying this file
// https://dop-orange.atlassian.net/wiki/spaces/WUWA/pages/1827602540/Nju+Tagging+DataLayer

interface IPushAddShippingInfoEventGA4Props {
  productId: string;
  numberCount: number;
  productPrice: number;
  shippingTier: string;
  itemCategory: string;
  downloadSpeed?: string;
}

export function pushAddShippingInfoEventGA4({
  productId,
  numberCount,
  productPrice,
  shippingTier,
  downloadSpeed,
  itemCategory,
}: IPushAddShippingInfoEventGA4Props) {
  if ("dataLayer" in window) {
    window.dataLayer.push({
      event: "add_shipping_info",
      ecommerce: {
        currency: "PLN",
        value: productPrice * numberCount,
        coupon: "",
        shipping_tier: shippingTier,
        items: [
          {
            item_id: productId,
            item_name:
              itemCategory === "Internet stacjonarny"
                ? "Nju internet stacjonarny"
                : "Nju subskrypcja",
            affiliation: "",
            coupon: "",
            discount: 0,
            index: 0,
            item_brand: "Nju",
            item_category: itemCategory,
            item_category2: "Nowy",
            item_category3: downloadSpeed ? `${downloadSpeed} Mb` : " ",
            item_category4: `${itemCategory}/Nowy`,
            item_variant: String(numberCount),
            item_list_name: "",
            location_id: "",
            price: productPrice,
            quantity: numberCount,
          },
        ],
      },
    });
  }
}
